/*
  Makes every heart on the page work.

  One fetch per page, not one per heart: a collection page can show sixty
  products, and sixty requests on a phone on mobile data is the difference
  between a page that works and one that gives up.

  Hearts are filled in after that fetch rather than rendered filled, because
  the page itself is cached and handed to every customer alike — Liquid cannot
  know whose page it is.
*/
(function () {
  'use strict';

  var saved = null;    // the ids this customer has saved, once known
  var products = null; // and the products behind them, for pages that show the list
  var loading = null;  // the in-flight fetch, so a page full of hearts shares one

  function hearts() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sp-wishlist]'));
  }

  function paintCount() {
    var badge = document.querySelector('[data-sp-wishlist-count]');
    if (!badge) return;
    var count = saved ? saved.length : 0;
    badge.textContent = count > 99 ? '99+' : String(count);
    // Hidden at zero rather than showing a 0, which only ever reads as
    // something being broken.
    badge.hidden = count === 0;
  }

  function paint() {
    if (!saved) return;
    hearts().forEach(function (button) {
      var on = saved.indexOf(button.getAttribute('data-sp-wishlist')) !== -1;
      button.classList.toggle('sp-heart--on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    paintCount();
  }

  // Tells the rest of the page that the saved list has changed, so anything
  // showing that list — the Saved items grid on the account page — can follow
  // without asking the server again, and without keeping a second copy that
  // can drift out of step with this one.
  function announce() {
    document.dispatchEvent(new CustomEvent('sp:wishlist', {
      detail: { productIds: saved || [] },
    }));
  }

  function load() {
    if (loading) return loading;
    loading = window.SP.getWishlist()
      .then(function (result) {
        saved = result.productIds;
        products = result.products;
        paint();
        announce();
        return result;
      })
      .catch(function () {
        // Signed out, offline, or an expired session. The hearts simply stay
        // empty and still work when clicked — the click will ask for a login
        // if one is needed.
        saved = null;
        // Cleared so a later caller gets a fresh attempt rather than
        // inheriting this failure for the rest of the page's life.
        loading = null;
        return { productIds: [], products: [] };
      });
    return loading;
  }

  // The one copy, for anyone who needs the whole list rather than just the
  // hearts. Shares the single fetch above: before this, the account page
  // asked for the list itself as well, so opening it cost two identical
  // requests on a phone that was already waiting.
  window.SPWishlist = {
    load: function () {
      if (!window.SP || !window.SP.isLoggedIn()) {
        return Promise.resolve({ productIds: [], products: [] });
      }
      if (saved && products) return Promise.resolve({ productIds: saved, products: products });
      return load();
    },
  };

  function toLogin() {
    var here = window.location.pathname + window.location.search;
    window.location.href = '/pages/login?view=sp-login&return_to=' + encodeURIComponent(here);
  }

  function onClick(event) {
    var button = event.target.closest('[data-sp-wishlist]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    if (!window.SP.isLoggedIn()) {
      toLogin();
      return;
    }

    var id = button.getAttribute('data-sp-wishlist');
    var turningOn = !button.classList.contains('sp-heart--on');

    // Fill it now and send afterwards. On a weak connection a heart that waits
    // for the server feels broken, and the customer taps it again.
    button.classList.toggle('sp-heart--on', turningOn);
    button.setAttribute('aria-pressed', turningOn ? 'true' : 'false');

    window.SP.toggleWishlist(id, turningOn)
      .then(function (productIds) {
        saved = productIds;
        paint();
        announce();
      })
      .catch(function () {
        // Put it back the way it was, so the page never claims something was
        // saved when it was not. Announcing the unchanged list is what puts a
        // removed card back on the account page.
        button.classList.toggle('sp-heart--on', !turningOn);
        button.setAttribute('aria-pressed', !turningOn ? 'true' : 'false');
        announce();
      });
  }

  function start() {
    if (!window.SP) return;
    // One listener on the document, so hearts added later — a collection page
    // loading its next rows — work without being wired up again.
    document.addEventListener('click', onClick, true);
    // Runs even on a page with no hearts, because the header's count is on
    // every page. A signed-out visitor fetches nothing.
    if (window.SP.isLoggedIn()) load();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
